/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CommitDescription = styled.div({
  margin: '10px 25px',
  whiteSpace: 'pre-wrap',
});

export const AuthorInfo = styled.div({
  'margin-top': token('space.200', '16px'),
  'margin-bottom': token('space.200', '16px'),
  display: 'flex',
  'align-items': 'center',
  'justify-content': 'space-between',
  'flex-wrap': 'wrap',
});
export const CommitDetails = styled.div({
  display: 'column',
  flexDirection: 'row',
  marginLeft: '0.2rem',
});

export const CopyHashIcon = styled.div({
  cursor: 'pointer',
  width: 'fit-content',
});

interface DrawerProps {
  isHovered: boolean;
}
export const CopyHashDrawer = styled.div<DrawerProps>(({ isHovered }) => {
  if (isHovered) {
    return {
      transition: 'opacity 200ms, transform 200ms',
      transform: 'translateX(0%)',
      opacity: 1,
      transitionDelay: '0ms',
    };
  } else {
    return {
      transition: 'opacity 200ms, transform 200ms',
      opacity: 0,
      transform: 'translateX(-30%)',
      transitionDelay: '200ms',
    };
  }
});

export const HashContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const SpinnerWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const AuthorAndCommitContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: token('space.100', '8px'),
});

export const TagListWrapper = styled.div({
  borderBottom: `1px ${token('color.border', colors.N40)} solid`,
  marginBottom: token('space.100', '8px'),
  paddingBottom: token('space.100', '8px'),
});

export const CreateTagWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const TagOverflowWarning = styled.div({
  display: 'flex',
  color: token('color.text.subtlest', colors.N300),
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
});

export const CommentWrapper = styled.div({
  margin: '10px 30px',
});

export const ParticipantRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: token('space.100', '8px'),
});

export const CommitCardWrapper = styled.div({
  margin: token('space.100', '8px'),
});

export const CommitCardLinkText = styled.span({
  fontWeight: 'normal',
});

export const LozengeWrapper = styled.div({
  margin: `0 ${token('space.100', '8px')}`,
});

export const BranchCardWrapper = styled.div({
  margin: `${token('space.100', '8px')} ${token('space.100', '8px')} 0`,
});

export const ConnectLinkWrapper = styled.a({
  marginTop: token('space.100', '8px'),
  display: 'block',
  cursor: 'pointer',
});
